import { Image, ImageProps } from '@chakra-ui/react'
import svg from 'assets/artwork/desk-people.svg'
import { forwardRef } from 'react'

export const DeskPeople = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    return <Image {...props} src={svg} alt="people surrounding a desk" ref={ref} />
})
